import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUserInfo } from '@bashaquerizwan/azaadi-packages';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly _userInfoUrl = environment.authApiUrl + '/user-info';
  private readonly _http = inject(HttpClient);

  getUserByToken(token: string) {
    return this._http.post<{ user: IUserInfo }>(this._userInfoUrl, {
      data: {
        sAccessToken: token,
      },
    });
  }
}
